import React, { useEffect } from 'react';
import CommonLayout from './layout/commonLayout';
import { IStep2, Wizard2 } from '../components/wizard';
import { useAppDispatch } from '../app/hooks';
import { updateSecondarySubset, updateWizardStepName, updateType } from '../slices/submitSlice';
import StepShape from '../components/steps/common/step_shape';
import Weight from '../components/steps/common/step_weight';
import StepRegistration from '../components/steps/common/step_registration';
import StepPhotoUpload from '../components/steps/common/step_photoUpload';
import { ItemTypes } from '../data/ItemDetails';
import { loadGraph } from '../lib/wizard';
import StepSubmit from '../components/steps/common/step_submit';
import StepReject from '../components/steps/common/step_reject';
import StepSelectSubmitType from '../components/submission/step_select_submit_type';
import Chat from '../components/steps/ai_submit_flow';
import { isRingAIChatExperiment } from '../lib/experiment';
import { schedulingStepName, shippingSchedulingSteps } from '../components/common/ShippingSchedulingSteps';

const createSteps = ({ submitChoice = false }): IStep2[] => [
  ...(submitChoice
    ? [
      {
        comp: StepSelectSubmitType,
        name: 'StepSelectSubmitType',
        caption: 'Submit an item',
        title: 'Choose how to describe your item:',
        disableBackButton: false,
        exits: {
          next: 'StepDiamondShape',
          chat: 'ChatFlowSubmission',
        },
      },
      {
        comp: Chat,
        name: 'ChatFlowSubmission',
        caption: 'Submit an item',
        disableBackButton: false,
        exits: {
          next: 'StepSubmit',
        },
      },
    ]
    : []),
  {
    comp: StepShape,
    name: 'StepDiamondShape',
    caption: 'Diamond Shape',
    title: 'What is the shape of your diamond?',
    disableBackButton: true,
  },
  {
    comp: Weight,
    name: 'StepCaratWeight',
    caption: 'Carat Weight',
    title: 'Great! And what is the carat weight of your diamond?',
  },
  {
    comp: StepSubmit,
    name: 'StepSubmit',
    caption: 'Submit',
    disableBackButton: true,
    exits: {
      next: 'StepRegistration',
      reject: 'StepReject',
    },
  },
  {
    comp: StepReject,
    name: 'StepReject',
    caption: 'Reject',
    disappearFromProgressBar: true,
    disableProgressBar: true,
    disableBackButton: true,
    exits: {
      restart: 'StepDiamondShape',
    },
  },
  {
    comp: StepRegistration,
    name: 'StepRegistration',
    caption: 'Register',
    itemRequired: true,
    skipOnlogin: true,
    disableBackButton: true,
  },
  {
    comp: StepPhotoUpload,
    name: 'StepPhotoUpload',
    caption: 'Upload photos',
    disappearFromProgressBar: true,
    disableProgressBar: true,
    disableBackButton: true,
    exits: {
      scheduleShipping: schedulingStepName,
    },
    final: true,
  },
  ...shippingSchedulingSteps,
];

function LooseDiamondPage() {
  const dispatch = useAppDispatch();
  const submitChoice = isRingAIChatExperiment();
  const steps = createSteps({ submitChoice });

  dispatch(updateType(ItemTypes.LooseDiamond));

  useEffect(() => {
    // default subset for earring to prevent wrong calculation for count of steps
    dispatch(updateSecondarySubset('diamond_center_stone'));
    dispatch(updateWizardStepName(steps[0].name));
  }, [dispatch, steps]);

  const stepsGraph = loadGraph(steps);

  return (
    <CommonLayout>
      <Wizard2 stepsGraph={stepsGraph} />
    </CommonLayout>
  );
}

export default LooseDiamondPage;
